import Dislocator from "dislocator";
import NetworkInterface from "./NetworkInterface";
import Api from "./Api";
import configureStore from "../store";

import CrashReporter from "@one.com/frontend-crash-reporter";
import project from "../../package.json";
import aecConfig from "./appEventCollectorConfig";

export default class ServiceLocator extends Dislocator {
  constructor() {
    super();

    this.register("networkInterface", () => {
      return new NetworkInterface();
    });

    this.register("api", ({ networkInterface }) => {
      return new Api({ networkInterface });
    });

    this.register("store", (serviceLocator) => configureStore(serviceLocator));

    this.register("crashReporter", ({ store }) => {
      return new CrashReporter({
        aecApp: aecConfig.app,
        aecUrl: aecConfig.url,
        aecEnv: aecConfig.env,
        additionalInfo: () => {
          return {
            version: project.version,
          };
        },
      });
    });
  }
}
